export enum VariableIO {
    INPUT = "ast_FunctionParameter",
    INPUT_TYPE = "ast_FunctionParameterType",
    OUTPUT = "variables_get_dynamic"
}

export enum BLOCK_TYPE {
    Evaluator = 'evaluator',
    Transformer = 'transformer',
    DataEnricher_API = 'api',
    DataEnricher_DB_Lookup = 'db-lookup',
    DataEnricher_Graph_Lookup = 'graph-lookup',
    DataEnricher_ML_Prediction = 'ml-prediction',
    Push_Webhook = 'webhook',
    Push_DB = 'db',
    Push_Queue = 'queue',
    Notification_Email = 'email',
    Notification_Slack = 'slack',
    System = 'system',
}

export enum BLOCK_FILE_PATH {
    block_code = "block.py",
    readme = "README.md",
    request_schema = "request_schema.json",
    response_schema = "response_schema.json",
    dockerfile = "Dockerfile",
    requirements = "requirements.txt",
    api_specification = 'api_specification.json',   //specific for Data Enricher API
    input_schema = 'input_schema.json',             //specific for Evaluator
    output_schema = 'output_schema.json',           //specific for Evaluator
    config = 'config.json',
    main_sql = 'main.sql',
}

export const Block_Default_Files: { [block_type: string]: string[] } = {
    [BLOCK_TYPE.Evaluator]: [
        BLOCK_FILE_PATH.block_code,
        BLOCK_FILE_PATH.dockerfile,
        BLOCK_FILE_PATH.input_schema,
        BLOCK_FILE_PATH.output_schema,
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.request_schema,
        BLOCK_FILE_PATH.requirements,
        BLOCK_FILE_PATH.response_schema,
    ],
    [BLOCK_TYPE.Transformer]: [
        BLOCK_FILE_PATH.block_code,
        BLOCK_FILE_PATH.dockerfile,
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.request_schema,
        BLOCK_FILE_PATH.requirements,
        BLOCK_FILE_PATH.response_schema,
    ],
    [BLOCK_TYPE.DataEnricher_API]: [
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.api_specification,
    ],
    [BLOCK_TYPE.DataEnricher_DB_Lookup]: [
        BLOCK_FILE_PATH.dockerfile,
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.main_sql,
        BLOCK_FILE_PATH.config,
        BLOCK_FILE_PATH.request_schema,
        BLOCK_FILE_PATH.response_schema,
    ],
    [BLOCK_TYPE.DataEnricher_Graph_Lookup]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.DataEnricher_ML_Prediction]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.Push_Webhook]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.Push_DB]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.Push_Queue]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.Notification_Email]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.Notification_Slack]: [
        BLOCK_FILE_PATH.readme,
    ],
    [BLOCK_TYPE.System]: [
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.block_code,
        BLOCK_FILE_PATH.dockerfile,
        BLOCK_FILE_PATH.readme,
        BLOCK_FILE_PATH.request_schema,
        BLOCK_FILE_PATH.requirements,
        BLOCK_FILE_PATH.response_schema,
    ],
}

export const getSecondaryBlocklycode = () => {
    return "# you can add python code here...";
}